
const m = window.require("@glimmer/runtime");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
